import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import getIsMenuFetched from '@core/reducers/menu/selectors/getIsMenuFetched';
import getMenuSections from '@shopDetails/selectors/getMenuSections';
import getExtendedMenuSelectedSection from '@shopDetails/selectors/getExtendedMenuSelectedSection';
import MenuSections from './MenuSections';

const mapStateToProps = createStructuredSelector({
  menuSections: getMenuSections,
  isMenuFetched: getIsMenuFetched,
  selectedSection: getExtendedMenuSelectedSection,
});

export default connect(mapStateToProps)(MenuSections);
